import { TimePicker } from 'antd';
import dayjs from 'dayjs';

interface CustomTimePickerProps {
  value?: number;
  onChange?: (date: number | undefined) => void;
  className?: string | undefined;
}

export default function CustomTimePicker({ onChange, value = 0, className }: CustomTimePickerProps) {
  return (
    <TimePicker
      id="component-timepicker"
      allowClear={false}
      minuteStep={5}
      showNow={false}
      format={'HH:mm'}
      value={dayjs().startOf('day').add(value, 'minutes')}
      onChange={(e) => {
        if (onChange && e) onChange(e.diff(dayjs().startOf('day'), 'minute'));
      }}
      className={className}
    />
  );
}
